export default "__VITE_ASSET__$twaJO7h__"